import PlanDetailsCompareDialog from './plan-details.vue';
import FullComparisonDialog from './full-comparison-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { mapState } from 'vuex';
import { plansof } from '@/utils/chain';

export default {
  props: {
    showPlanDetails: Boolean,
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    })
  },
  created() {
    this.planDetailsCompareDialog = new ServiceConfirm(PlanDetailsCompareDialog);
    this.fullComparisonDialog = new ServiceConfirm(FullComparisonDialog);
  },
  methods: {
    async showPlanDetailDialog() {
      // do tracking when open plan details dialog
      this.$tracking.buyInteraction('plan details selected',this.trackingPlanKey);
      const selectedPlans = this.orderSelectedPlans.length
        ? this.orderSelectedPlans
        : plansof(this.planMapFlat).type(this.planType).annual().get().sort((a,b) => a.capacity - b.capacity).slice(0,1);

      await this.planDetailsCompareDialog.confirm({
        selectedPlans: selectedPlans,
        planType: this.planType,
        trackingKey: this.trackingPlanKey
      });

      await this.fullComparisonDialog.confirm({
        planType: this.planType,
      }).catch(() => {
        if (this.$context.is.modal) {
          this.showPlanDetailDialog();
        }
      });
    },
  },
};
